import { render, staticRenderFns } from "./MatchStock.vue?vue&type=template&id=5ae2c1b4&"
import script from "./MatchStock.vue?vue&type=script&lang=js&"
export * from "./MatchStock.vue?vue&type=script&lang=js&"
import style0 from "./MatchStock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports